<template>
  <div class="comment-operation">
    <div class="comment-delete">
      <span
        v-if="id===item.userId"
        class="reply-like-icon iconfont iconshanchu"
        @click="commentDelete"
      ></span>
      <span
        v-if="id===item.userId"
        class="delete-font"
      >删除</span>
    </div>
    <div class="comment-reply">
      <span
        class="reply-like-icon iconfont"
        :class="isreply?'iconshouqipinglun':'iconpinglun-huifupinglun'"
        @click="reply"
      ></span>
      <span class="reply-font">{{isreply?'收起回复': '回复'}}</span>
    </div>
    <div class="comment-like">
      <span
        @click="toggleLike"
        class="comment-like-icon iconfont"
        :class="isLike ? 'iconyizan' : 'iconzan'"
      ></span>
      <span
        :class="
          isLike
            ? 'comment-like-number number-yizan'
            : 'comment-like-number number-zan'
        "
        v-text="item.adoptNum"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "CommentOperation",
  data() {
    return {
      id: ""
    };
  },
  props: {
    isreply: {
      type: Boolean,
      default: false
    },
    ishot: {
      type: Number
    },
    likeNumber: {
      type: Number
    },
    isLike: {
      type: Boolean,
      default: false
    },
    //当前评论对象
    item: {
      type: Object
    },
    index: {
      type: Number,
      default: null
    },
    childindex: {
      type: Number,
      default: null
    }
  },
  created() {
    this.id = this.$cookie.get("userInfo_userId");
  },
  methods: {
    commentDelete() {
      this.$emit("commentDelete");
    },
    reply() {
      this.$emit("reply");
    },
    toggleLike() {
      this.$emit("toggleLike");
    }
  }
};
</script>
<style lang="less">
.comment-operation {
  width: 160px;
  display: flex;
  div {
    flex-grow: 1;
  }
}
.comment-delete {
  display: flex;
  flex-direction: column;
  min-width: 50px;
  .iconshanchu {
    cursor: pointer;
    font-size: 19px;
  }
  .delete-font {
    font-size: 12px;
  }
}
.comment-reply {
  min-width: 60px;
}
.comment-like {
  min-width: 50px;
}
</style>
